import { BBPBackendService } from "./BBPBackendService";
import { BBPFrontendService } from "./BBPFrontendService";
/**
 * Factory for creating SAC services
 */
export class BBPServiceFactory {
    /**
     * Create an BBP service for backend
     * @returns An BBP service object for backend
     */
    static createForBackend(fetchImpl) {
        return new BBPBackendService(fetchImpl);
    }
    /**
     * Create an BBP service for frontend
     * @param firebaseAuth - firebase auth instance
     * @returns An BBP service object for frontend
     */
    static createForFrontend(url, firebaseAuth) {
        return new BBPFrontendService(url, firebaseAuth);
    }
}
